<ngx-loader [show]='CargandoFases' [template]="template"> Cargando... </ngx-loader>

<div class="container">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
            <a [ngClass]="{'nav-link':true,'active': listaFase.fase1, 'disabled':listaFase.bloqueo1 }" id="personal-tab"
                data-toggle="tab" href="#personal" role="tab" aria-controls="profile" aria-selected="false">
                Datos Personales
                <em class="mdi mdi-cloud-upload"></em>
            </a>
        </li>
        <li class="nav-item" role="presentation">
            <a [ngClass]="{'nav-link':true,'active': listaFase.fase3, 'disabled':listaFase.bloqueo3 }" id="home-tab"
                data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">
                Arancel de carrera
                <em class="mdi mdi-cloud-outline"></em>
            </a>
        </li>
        <li class="nav-item" role="presentation">
            <a [ngClass]="{'nav-link':true,'active': listaFase.fase4, 'disabled':listaFase.bloqueo4 }" id="profile-tab"
                data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">
                Documentos Requeridos
                <em class="mdi mdi-cloud-upload"></em>
            </a>
        </li>
        <li class="nav-item" role="presentation">
            <a [ngClass]="{'nav-link':true,'active': listaFase.fase5, 'disabled':listaFase.bloqueo5 }" id="contrato-tab"
                data-toggle="tab" href="#contrato" role="tab" aria-controls="profile" aria-selected="false">
                Firma de Contrato
                <em class="mdi mdi-cloud-upload"></em>
            </a>
        </li>
        <li class="nav-item" role="presentation">
            <a [ngClass]="{'nav-link':true,'active': listaFase.fase6, 'disabled':listaFase.bloqueo6 }" id="pago-tab"
                data-toggle="tab" href="#pago" role="tab" aria-controls="profile" aria-selected="false">
                Pago
                <em class="mdi mdi-cloud-upload"></em>
            </a>
        </li>
        <li class="nav-item" role="presentation">
            <a [ngClass]="{'nav-link':true,'active': listaFase.fase7, 'disabled':listaFase.bloqueo7 }"
                id="matricula-tab" data-toggle="tab" href="#matricula" role="tab" aria-controls="profile"
                aria-selected="false">
                Confirmación de Matricula
                <em class="mdi mdi-cloud-upload"></em>
            </a>
        </li>
    </ul>
    <app-fase [lista]='listaFase'></app-fase>
    <div class="tab-content" id="myTabContent">
        <div class="tab-pane" [ngClass]="{'fade show active':listaFase.fase1}" id="personal" role="tabpanel"
            aria-labelledby="personal-tab">
            <app-personal [Alumno]='Alunmno' (AlumnoOut)='setAlumno($event)' [FaseActual]='FaseActual'
                (Fase)="UpdateFase($event, 'personal')" [GoToContrato]="operacionContrato === 'cdp'"
                (onGoToContrato)="onGoToContrato($event)" (MayorEdad)='SetMayorEdad($event)'></app-personal>
        </div>
        <div class="tab-pane fade" [ngClass]="{'fade show active':listaFase.fase2}" id="educacion" role="tabpanel"
            aria-labelledby="educacion-tab">
            <app-educacion [IdProceso]='Idproceso' [faseActual]='FaseActual' [ultimafase]="ultimafase"
                (Fase)="UpdateFase($event, 'educacion')" (CursandoCuartoMedio)='setCuartoMedio($event)'></app-educacion>
        </div>
        <div class="tab-pane" [ngClass]="{'fade show active':listaFase.fase3}" id="home" role="tabpanel"
            aria-labelledby="home-tab">
            <app-simular [IdProcesoActual]='Idproceso' (Fase)='UpdateFase($event)' (Panelcrm)='setPanel($event)'
                [changeCarreraCount]="_changeCarreraCount" [faseActual]='FaseActual' [ultimafase]='ultimafase'>
            </app-simular>
        </div>
        <div class="tab-pane" [ngClass]="{'fade show active':listaFase.fase4}" id="profile" role="tabpanel"
            aria-labelledby="profile-tab">
            <app-documentos [IdProceso]='Idproceso' [Panel]='Panel' [CuartoMedio]='CursandoCuartoMedio'
                (Fase)='UpdateFase($event)' (CambiarCarrera)='CambiarCarrera()'
                [changeDocumentosCount]="_changeDocumentosCount" (GoToMatricula)='GoToMatricula()'
                [MayorEdad]='mayorEdad' [faseActual]='FaseActual' [ultimafase]='ultimafase'></app-documentos>
        </div>
        <div class="tab-pane" [ngClass]="{'fade show active':listaFase.fase5}" id="contrato" role="tabpanel"
            aria-labelledby="contrato-tab">
            <app-contrato *ngIf="!MetodoFirma" [faseActual]='FaseActual' [IdProceso]='Idproceso' [Alumno]='Alunmno' [ultimafase]='ultimafase'
                (Fase)="UpdateFase($event)"></app-contrato>
			<app-contratoecert *ngIf="MetodoFirma" [faseActual]='FaseActual' [IdProceso]='Idproceso' [Alumno]='Alunmno' [ultimafase]='ultimafase'
                (Fase)="UpdateFase($event)"></app-contratoecert>
        </div>
        <div class="tab-pane" [ngClass]="{'fade show active':listaFase.fase6}" id="pago" role="tabpanel"
            aria-labelledby="pago-tab">
            <app-pago [IdProceso]='Idproceso' [faseActual]='FaseActual' [ultimafase]='ultimafase'
                (Fase)="UpdateFase($event)"></app-pago>
        </div>
        <div class="tab-pane" [ngClass]="{'fade show active':listaFase.fase7}" id="matricula" role="tabpanel"
            aria-labelledby="matricula-tab">
            <app-borrador [idProceso]='Idproceso' [faseActual]='FaseActual' (UpdateDocumentos)="GoToValidarDocumento()">
            </app-borrador>
        </div>
    </div>
</div>